<template>
  <section>
    <h5 class="mb-2">Enter New Mobile Number</h5>
    <small
      class="d-block mb-4"
      :style="{
        color: webDesign.design.main_color,
      }"
    >
      <i class="bi bi-exclamation-circle mr-1" aria-hidden="true"></i>
      <strong>New mobile number will only apply once OTP is verified.</strong>
    </small>
    <b-row>
      <b-col md="6">
        <b-form @submit.prevent="submitNewMobileNumber" autocomplete="off">
          <b-form-group label="Current Mobile Number">
            <b-input-group prepend="+63">
              <b-form-input v-model="customer.mobile_number" disabled>
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="New Mobile Number"
            :state="isValid('mobile_number')"
            :invalid-feedback="errorMessage('mobile_number')"
          >
            <b-input-group prepend="+63">
              <input
                v-model="form.mobile_number"
                :maxlength="mobileNumberLength"
                type="text"
                pattern="[0-9]*"
                inputmode="numeric"
                class="form-control"
                ref="mobileNumber"
              />
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="Confirm Mobile Number"
            :state="isValid('confirm_mobile_number')"
            :invalid-feedback="errorMessage('confirm_mobile_number')"
          >
            <b-input-group prepend="+63">
              <input
                v-model="form.confirm_mobile_number"
                :maxlength="mobileNumberLength"
                type="text"
                pattern="[0-9]*"
                inputmode="numeric"
                class="form-control"
              />
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-button
              variant="primary"
              type="submit"
              class="border-0 px-5"
              pill
              :style="{
                'background-color':
                  webDesign && webDesign.design
                    ? webDesign.design.main_color
                    : null,
                color:
                  webDesign && webDesign.design
                    ? webDesign.design.button_text_color
                    : null,
              }"
              :disabled="
                loading || isInvalidMobileNumber || isInvalidConfirmMobileNumber
              "
            >
              Save Changes
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

function initForm() {
  return {
    mobile_number: "",
    confirm_mobile_number: "",
  };
}

export default {
  name: "ChangeMobileNewNumber",
  props: ["webDesign", "customer"],
  data() {
    return {
      form: initForm(),
      mobileNumberLength: 10,
    };
  },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
    }),
    ...mapState("merchant", {
      customerPortalToken: (state) => state.customerPortalToken,
    }),
    ...mapState("customer", {
      errors: (state) => state.errors,
      loading: (state) => state.loading,
    }),
    isInvalidMobileNumber() {
      return this.form.mobile_number.match(/^(9)\d{9}$/g) === null;
    },
    isInvalidConfirmMobileNumber() {
      return this.form.confirm_mobile_number.match(/^(9)\d{9}$/g) === null;
    },
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapActions({
      validateNewMobileNumber: "customer/validateNewMobileNumber",
      sendCustomerNewNumberOtp: "customer/sendCustomerNewNumberOtp",
    }),
    ...mapMutations({
      setErrors: "customer/SET_ERRORS",
    }),
    submitNewMobileNumber() {
      const errors = {};
      const { mobile_number, confirm_mobile_number } = this.form;

      if (this.customer.mobile_number === mobile_number)
        errors["mobile_number"] =
          "New mobile number needs to be different from the current mobile number.";

      if (mobile_number !== confirm_mobile_number)
        errors["confirm_mobile_number"] =
          "The Confirm Mobile Number must match your New Mobile Number.";

      this.setErrors(errors);

      if (!this.errors || Object.keys(this.errors).length === 0)
        this.handleValidateNewMobileNumber();
    },
    async handleValidateNewMobileNumber() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          mobile: this.form.mobile_number,
        },
      };
      await this.validateNewMobileNumber(request);

      if (!this.errors || Object.keys(this.errors).length === 0)
        this.handleSendOtp();
      else this.handleModalError();
    },
    handleModalError() {
      if (this.errors) {
        let errorMessage;

        if (this.errors.message) errorMessage = this.errors.message;

        if (this.errors?.errors?.message) {
          const error = this.errors.errors.message;

          errorMessage = Array.isArray(error) ? error[0] : error;
        }

        this.$emit("set-change-mobile-modal-message", errorMessage);
        this.$bvModal.show("change-mobile-number-generic-modal");
      }
    },
    async handleSendOtp() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          mobile_number: this.form.mobile_number,
          action: "UPDATE_MOBILE_NUMBER",
        },
      };

      await this.sendCustomerNewNumberOtp(request);

      if (!this.errors || Object.keys(this.errors).length === 0) {
        this.$emit("change-component", "ChangeMobileOTP");
        this.$emit("set-customer-update-mobile", {
          current_mobile_number: this.customer.mobile_number,
          new_mobile_number: this.form.mobile_number,
          confirm_mobile_number: this.form.confirm_mobile_number,
        });
      } else this.handleModalError();
    },
    isNumber(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNumber(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    trimNumber: function (ref) {
      this.$nextTick(() => {
        if (this.form[ref]) this.form[ref] = this.form[ref].replace(/\D/g, "");
      });
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors[field] ? false : true;
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }
      return this.errors[field];
    },
  },
  watch: {
    "form.mobile_number"(mobileNumber) {
      this.form.mobile_number = mobileNumber.replace(/\D/g, "");
      
      if (this.errors) this.setErrors(null);
    },
    "form.confirm_mobile_number"(confirmMobileNumber) {
      this.form.confirm_mobile_number = confirmMobileNumber.replace(/\D/g, "");
      
      if (this.errors) this.setErrors(null);
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.mobileNumber.focus();
    });
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/views/profile/_change.mobile";
</style>
